var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5887 4.56055C18.8479 10.2406 14.5802 16.5731 7.02516 16.5731C4.72776 16.5731 2.59041 15.9039 0.790161 14.758C2.94876 15.0111 5.1031 14.415 6.8127 13.0863C5.0337 13.054 3.5309 11.8856 3.01108 10.2814C3.64988 10.4023 4.27876 10.3672 4.84957 10.2125C2.89352 9.82167 1.54227 8.07265 1.58618 6.20131C2.13574 6.50359 2.76179 6.68496 3.42892 6.70605C1.61734 5.50395 1.1046 3.12928 2.16974 1.31418C4.17536 3.75775 7.17388 5.36476 10.5548 5.53348C9.96136 3.00837 11.8919 0.574646 14.5193 0.574646C15.6879 0.574646 16.7459 1.06533 17.4881 1.84985C18.4144 1.66989 19.287 1.33246 20.0716 0.869898C19.7671 1.8133 19.1226 2.60345 18.2827 3.10397C19.1056 3.00556 19.8903 2.78904 20.6184 2.46707C20.0745 3.27972 19.3861 3.99114 18.5887 4.56055Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.08eafea7.svg";
export { ForwardRef as ReactComponent };